import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER, square } from '@/styles/common.styled';
import { FLEX_COLUMN_DIV, FLEX_DIV } from '@/styles/common.styled.component';

export const Header = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background-color: ${GRAY(10)};
    padding: 11px 16px;
`;

export const Title = styled(FLEX_DIV)`
    ${FLEX_CENTER}
    padding: 0;
    margin: 0;

    svg {
        ${square(16)}
        margin-right: 8px;
    }

    h1 {
        flex: 1;
        color: ${GRAY(100)};
        font-size: 14px;
        font-weight: 500;
        margin-right: 6px;
    }
`;

export const Content = styled(FLEX_COLUMN_DIV)`
    width: 100%;
`;

export const Row = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    color: #080a0d;
    overflow: hidden;

    &:not(:last-child) {
        border-bottom: 1px solid #dfe3e5;
    }
`;

export const RowWrapper = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const RowTitle = styled.span`
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    color: #080a0d;
`;

export const AxisControls = styled(FLEX_DIV)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
`;

export const SwitchesWrapper = styled(FLEX_DIV)`
    display: flex;
    align-items: center;
`;

export const SwitchGroup = styled(FLEX_DIV)`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Divider = styled.div`
    width: 1px;
    height: 16px;
    background-color: var(--color-gray-50);
    margin: 0 16px;
`;

export const AxisLabel = styled.span`
    color: var(--color-gray-80);
    text-align: right;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: var(--font-family-primary);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;

    input {
        width: 238px;
        height: 34px;

        border-radius: 2px;
        border: 1px solid #bdc2c7;
        padding: 8px 12px;
        font-family: var(--font-family-primary);
        font-weight: 400;
        font-size: 13px;
        line-height: 100%;
        color: #080a0d;
        outline: none;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type='number'] {
            -moz-appearance: textfield;
        }

        &::placeholder {
            color: #bdc2c7;
        }

        &:disabled {
            background-color: ${GRAY(5)};
            color: ${GRAY(50)};
            cursor: not-allowed;
        }
    }
`;

export const ErrorText = styled.div`
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #c72e2c;
    width: 280px;
`;

export const InputGroup = styled(FLEX_DIV)`
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const ComponentWrapper = styled(FLEX_COLUMN_DIV)`
    justify-content: space-between;
    align-items: center;

    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
`;

export const ResetButton = styled.button`
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #0054c6;
    cursor: pointer;
    padding: 0;
`;

export const AxisSection = styled(FLEX_COLUMN_DIV)`
    width: 100%;
    border-bottom: 1px solid ${GRAY(20)};
    padding: 16px 0;

    &:last-child {
        border-bottom: none;
    }
`;

export const AxisHeader = styled(FLEX_DIV)`
    width: 100%;
    padding: 0 16px;
    margin-bottom: 16px;
    font-weight: 500;
    color: ${GRAY(90)};
`;
